// TextInputControlView.js
import BasePropertyView from 'BasePropertyView.js';
import eventBus     from 'EventBus.js'
import constants    from "Constants.js";
import template     from 'inline/editable-control.ejs';
import areaTemplate     from 'inline/editable-control-textarea.ejs';

class EditableControlView extends BasePropertyView   {

    initialize( opts ) {
        console.log('init EditableControlView');
        this.template = template;
        if(this.model.get('factoryKey') === 'control_bullet_text'){
            this.template = areaTemplate;
        }

        this.tagName = 'div';
        this.events = {
            'change #editableControl' : 'updateAttributes',
            'blur textarea'   : 'lostFocus',
            'focus textarea'   : 'getFocus'
            //'change #editableControl' : 'updateAttributes'
        };
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        var propName = ev.currentTarget.name;
        var propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }
    
    render() {
        console.log('render EditableControlView');
        const self = this;

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }



        $('#editableControl').select();

        this.delegateEvents();
        return this;
    }


}

export default EditableControlView;
